<template>
  <div>
    <div ref="backDiv" id="back-div" v-show="isActive" class="back-div"></div>
    <div
      id="drawer"
      class="drawer bg-white"
      :class="{ active: isActive }"
      :style="getStyle()"
    >
      <div class="d-flex justify-content-between">
        <a
          class="hamburger clearfix theme-link"
          @click.prevent="$emit('closed')"
        >
          <img
            src="@/assets/newUi/icons/arrow-left.png"
            class="icon-back-arrow"
          />
        </a>
      </div>

      <!--      <Transition name="fade">-->
      <!--        <a-->
      <!--          v-show="isOpen"-->
      <!--          v-if="getLogo"-->
      <!--          class="clearfix theme-link"-->
      <!--          @click.prevent="closeDrawer()"-->
      <!--          style="margin-left: 5px"-->
      <!--        >-->
      <!--          <img style="width: 5rem; height: 5rem"  :src="getLogo" class="logo" />-->
      <!--        </a>-->
      <!--      </Transition>-->

      <div class="container mb-3">
        <ul class="nav clearfix">
          <li class="nav-drawer">
            <span :style="getTitleStyle()">{{ getTitleText() }}</span>
          </li>

          <div class="row col-10">
            <li>
              <span class="new-drawer-content">
                {{ currentStoreDoc.Location.Address }}
                <br />
                {{ currentStoreDoc.Location.Suburb }}
                {{ currentStoreDoc.Location.State }}
              </span>
            </li>
            <li>
              <span v-if="storeClosed" class="new-drawer-content">
                {{ $t("message.currentlyClosed") }},
                {{ $t("message.opensTomorrow") }}
                {{ opening && opening.openTime }}
              </span>

              <span class="new-drawer-content" v-else>
                {{ $t("message.openFrom") }}
                <span>
                  {{ getOperatingHours(currentStoreDoc).openTime }}
                </span>
                {{ $t("message.toName") }}
                <span>
                  {{ getOperatingHours(currentStoreDoc).closeTime }}
                </span>
              </span>
            </li>

            <Transition name="slide">
              <div v-if="isOpen">
                <li class="mt-4" v-if="user">
                  <router-link to="/profile">
                    {{ $t("message.myAccount") }}
                  </router-link>
                </li>
                <li class="mt-4" v-if="user && (storeSupportsLoyaltyPoints || storeSupportEarningLoyaltyPoints)">
                  <router-link
                    :to="{
                      name: 'loyalty',
                      params: {
                        storeid: currentStoreDoc.ID,
                        storename: currentStoreDoc.Name,
                      },
                    }"
                  >
                    {{ $t("message.loyalty") }}
                  </router-link>
                </li>

                <li class="mt-4" v-if="user">
                  <router-link
                    :to="{
                      name: 'orderhistory',
                      params: {
                        storeid: currentStoreDoc.ID,
                        storename: currentStoreDoc.Name,
                      },
                    }"
                  >
                    {{ $t("message.orderHistory") }}
                  </router-link>
                </li>

                <li class="mt-4" v-if="user">
                  <router-link
                    :to="{
                      name: 'ordertracking',
                      params: {
                        storeid: currentStoreDoc.ID,
                        storename: currentStoreDoc.Name,
                      },
                    }"
                  >
                    {{ $t("message.orderTracking") }}
                  </router-link>
                </li>

                <li class="mt-4" v-if="giftCards">
                  <router-link
                    :to="{
                      name: 'giftstorev2',
                      params: {
                        storeid: currentStoreDoc.ID,
                        storename: currentStoreDoc.Name,
                      },
                    }"
                  >
                    {{ $t("message.giftcard") }}
                  </router-link>
                </li>

                <li
                  class="mt-4"
                  v-if="user && $route.name != 'mainpage'"
                  @click="goToMainPage"
                >
                  {{ capitalizeFirstLetter($t("message.stores")) }}
                </li>
              </div>
            </Transition>
          </div>

          <div v-if="storeSupportsDelivery" class="mt-4 w-100">
            <button
              class="btn btn-light text-dark btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center"
              @click="setOrderType(0)"
            >
              <span class="new-menu-btn">{{
                $t("message.viewDeliveryMenu")
              }}</span>

              <!--              <span v-show="loading">-->
              <!--                  <i class="spin ml-4" />-->
              <!--                </span>-->
            </button>
          </div>

          <div v-if="storeSupportsPickup" class="mt-1 w-100">
            <button
              class="btn btn-primary btn-light text-dark btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center"
              @click="setOrderType(2)"
            >
              <span class="new-menu-btn">
                {{ $t("message.viewPickupMenu") }}</span
              >
            </button>
          </div>

          <div v-if="storeSupportsDinein" class="mt-1 w-100">
            <button
              class="btn btn-light text-dark btn-primary btn-sign-in btn-lg w-100 shadow d-flex justify-content-center align-items-center"
              @click="setOrderType(1)"
            >
              <span class="new-menu-btn">
                {{ $t("message.viewDineInMenu") }}</span
              >
            </button>
          </div>

          <div class="mt-3 w-100" v-if="viewConfig.LogIn">
            <div v-if="user">
              <button
                class="btn btn-primary btn-sign-in btn-dark btn-lg w-100 shadow d-flex justify-content-center align-items-center"
                @click="signOut"
              >
                <span class="new-register-btn">
                  {{ $t("message.logOut") }}</span
                >
              </button>
            </div>
            <div class="mt-3 w-100" v-else>
              <button
                class="btn btn-primary btn-sign-in btn-dark btn-lg w-100 shadow d-flex justify-content-center align-items-center"
                @click="openLogin"
              >
                <span class="new-register-btn">
                  {{ $t("message.signIn") }}
                </span>
              </button>
              <li class="mt-4">
                <span class="font-13">
                  {{ $t("message.haventGotAnAccount") }}?
                  <a href="#" class="theme-link-blue" @click="openRegister">
                    {{ $t("message.register") }}</a
                  >
                </span>
              </li>
            </div>
          </div>
        </ul>
      </div>

      <poweredby />
    </div>
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s ease;
  transition-duration: 3s;
  animation-duration: 3s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transition-duration: 3s;
  animation-duration: 3s;
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}

.slide-enter {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { capitalizeFirstLetter } from "../../filters/capitalizeFirstLetter";
import Poweredby from "@/components/shared/poweredby";
import {
  getCurrentDate,
  IsStoreOpenAtTime,
  operatingHours,
} from "@/api/helpers/datetimeHelper";
import {
  CONSTANT_ORDER_TYPE_DELIVERY,
  CONSTANT_ORDER_TYPE_DINEIN,
  CONSTANT_ORDER_TYPE_PICKUP,
} from "@/constants/strings";
import { interpolate } from "@/api/helpers/stringHelper";
import { orderTypeHelper } from "@/api/helpers/orderTypeHelper";

export default {
  name: "NewDrawer",
  components: { Poweredby },
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "viewConfig",
      "mobileStyles",
      "selectedCompany",
      "currentStoreDoc",
      "getDeliveryIsLoading",
      "hqDoc",
      "storeSupportsLoyaltyPoints",
      "getFirstValidRedemptionRule",
      "dbuser",
      "getOrderTypeModalDisplay",
      "getDefaultMenu",
      "storeSupportEarningLoyaltyPoints",
    ]),
    getLoyaltyMessage() {
      if (!this.getFirstValidRedemptionRule) return "";
      return interpolate(
        this.$t("message.collectGetFree"),
        this.getFirstValidRedemptionRule.Point,
        this.getFirstValidRedemptionRule.Name
      );
    },
    storeSupportsDelivery() {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      if (!this.selectedCompany.EnablePreoderForDelivery) {
        now = now.plus({
          minutes: this.selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.selectedCompany.IsInOperation,
          now
        );
      }
      return (
        this.viewConfig.Delivery &&
        (storeOpen || this.selectedCompany.EnablePreoderForDelivery)
      );
    },
    storeSupportsDinein() {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      now = now.plus({
        minutes: this.selectedCompany.OrderPreparationTime,
      });
      var storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      return this.viewConfig.EatIn && storeOpen;
    },
    storeSupportsPickup() {
      var now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      var storeOpen = IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
      if (!this.selectedCompany.EnablePreoderForPickup) {
        now = now.plus({
          minutes: this.selectedCompany.OrderPreparationTime,
        });
        storeOpen = IsStoreOpenAtTime(
          this.selectedCompany.BlackoutDates,
          this.selectedCompany.OperatingHours,
          this.selectedCompany.IsInOperation,
          now
        );
      }
      return (
        this.viewConfig.PickUp &&
        (storeOpen || this.selectedCompany.EnablePreoderForPickup) &&
        !this.pickupDisabled
      );
    },
    storeClosed() {
      const now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
      return !IsStoreOpenAtTime(
        this.selectedCompany.BlackoutDates,
        this.selectedCompany.OperatingHours,
        this.selectedCompany.IsInOperation,
        now
      );
    },

    opening() {
      if (this.selectedCompany.OperatingHours) {
        const now = getCurrentDate(this.selectedCompany.TimezoneIanaFormat);
        return operatingHours(
          this.selectedCompany.BlackoutDates,
          now,
          this.selectedCompany.OperatingHours
        );
      } else {
        return null;
      }
    },

    getLogo() {
      return this.hqDoc ? this.hqDoc.Logo : this.currentStoreDoc.Logo;
    },

    giftCards() {
      if (!this.getDefaultMenu) return false;
      if (
        this.getDefaultMenu.SpecialCategories &&
        this.getDefaultMenu.SpecialCategories.SCTypeGiftcard &&
        this.getDefaultMenu.SpecialCategories.SCTypeGiftcard.SubMenuItems &&
        this.getDefaultMenu.SpecialCategories.SCTypeGiftcard.SubMenuItems
          .length > 0
      ) {
        return true;
      }
      return false;
    },
  },

  mounted() {
    const that = this;
    if (this.$refs.backDiv) {
      this.$refs.backDiv.onclick = function () {
        if (that.isActive) {
          that.$emit("closed");
        }
      };
    }
  },
  watch: {
    isActive(val) {
      this.toggleAnimation(val);
    },
  },

  methods: {
    ...mapActions(["logout", "setOverlayIndex"]),
    ...mapMutations([
      "setShowOverlay",
      "setOrderTypeModalDisplay",
      "setSelectedMenuType",
      "setIsDelivery",
    ]),
    capitalizeFirstLetter,
    signOut() {
      this.logout();
      this.navigateShoppingcart();
    },
    navigateShoppingcart() {
      if (window.location.pathname.indexOf("giftcards") != -1)
        this.$router.push("/store/" + this.currentStoreDoc.Name + "/giftcards");
      else this.$router.push("/store/" + this.currentStoreDoc.Name);
    },
    getStyle() {
      var styles = [];
      // styles.push(this.mobileStyles.primaryColourImportant);
      // styles.push(this.mobileStyles.nav);
      return styles;
    },
    openLogin() {
      this.$emit("closed");
      this.setOverlayIndex(0);
      this.setShowOverlay(true);
    },
    openRegister() {
      this.$emit("closed");
      this.setOverlayIndex(2);
      this.setShowOverlay(true);
    },
    goToMainPage() {
      if (this.$route.name === "mainpage") {
        this.$emit("closed");
      } else {
        this.$router.push({ name: "mainpage" });
      }
    },
    getTitleStyle() {
      var styles = [];
      styles.push({
        "font-size": "2rem",
      });
      return styles;
    },

    getContentStyle() {
      var styles = [];
      styles.push({
        "font-size": "13px",

        margin: "25px 0px",
      });
      return styles;
    },
    setOrderType(index) {
      this.orderTypeIndex = index;
      switch (index) {
        case 0:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DELIVERY);
          this.setIsDelivery(true);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_DELIVERY);
          break;
        case 1:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_DINEIN);
          this.setIsDelivery(false);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_DINEIN);
          break;
        case 2:
          this.setSelectedMenuType(CONSTANT_ORDER_TYPE_PICKUP);
          this.setIsDelivery(false);
          orderTypeHelper.setOrderType(CONSTANT_ORDER_TYPE_PICKUP);
          break;
      }
      this.$emit("closed");
      this.setOrderTypeModalDisplay(false);

      this.$nextTick(() => {
        this.setOrderTypeModalDisplay(true);
        this.$forceUpdate();
      });
    },

    // nextButtonClickHandler() {
    //   if (this.step === 1) {
    //     const value =
    //         this.orderTypeIndex === 0
    //             ? CONSTANT_ORDER_TYPE_DELIVERY
    //             : this.orderTypeIndex === 1
    //                 ? CONSTANT_ORDER_TYPE_DINEIN
    //                 : CONSTANT_ORDER_TYPE_PICKUP;
    //
    //     orderTypeHelper.setOrderType(value);
    //     if (this.orderTypeIndex == 1) {
    //       this.hideModal();
    //     } else if (this.orderTypeIndex === 2) {
    //       this.step++;
    //     }
    //   } else if (this.step === 2) {
    //     sessionStorage.setItem(
    //         CONSTANT_DELIVERY_ADDRESS,
    //         JSON.stringify(this.deliveryLocation)
    //     );
    //   } else if (this.step === 3) {
    //     sessionStorage.setItem(CONSTANT_DELIVERY_TIME, this.scheduledTime);
    //     this.hideModal();
    //   } else {
    //     this.hideModal();
    //   }
    //
    //   this.step++;
    // },

    getOperatingHours(storedoc) {
      var now = getCurrentDate(storedoc.TimezoneCity);
      return (
        operatingHours(storedoc.BlackoutDates, now, storedoc.OperatingHours) ||
        {}
      );
    },

    getTitleText() {
      const storeName = this.currentStoreDoc.Name;
      return storeName.length > 30
        ? storeName.substring(0, 30) + "..."
        : storeName;
    },

    closeDrawer() {
      this.$emit("closed");
    },

    toggleAnimation(val) {
      setTimeout(() => {
        this.isOpen = val;
      }, 600);
    },
  },
};
</script>
